module.exports = __webpack_public_path__ + "img/user-work.535853ed.svg";